import { useEffect, useState } from 'react'

import throttle from 'lodash/throttle'

/**
 * Get progress when scrolling.
 * @returns the progress between 0 and 100 included.
 */
export function useProgressOnScroll() {
    const [progress, setProgress] = useState(0)

    function computeProgress() {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight
        const scrolled = (winScroll / height) * 100
        setProgress(scrolled)
    }

    useEffect(() => {
        window.onscroll = throttle(computeProgress, 100)
        computeProgress()
        return () => {
            window.onscroll = null
        }
    }, [])

    return progress
}
